import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../pages/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser, authLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !currentUser) {
      const currentPath = location.pathname.toLowerCase();
      if (!currentPath.includes("login") && !currentPath.includes("signup")) {
        navigate("/login", { state: { from: location.pathname + location.search }, replace: true });
      }
    }
  }, [currentUser, authLoading, location.pathname, location.search, navigate]);

  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <p className="text-blue-600 font-bold animate-pulse text-lg">
          सुरक्षा जाँच की जा रही है...
        </p>
      </div>
    );
  }

  if (!currentUser) {
    return null;
  }

  return children;
};

export default ProtectedRoute;